import CryptoJS from 'crypto-js'

const SECRET_KEY = process.env.VUE_CRYPTO_SECRET_KEY;
export function encryptData(data) {
    return btoa(data);

    // if (!SECRET_KEY) {
    //     return btoa(JSON.stringify(data));
    // }
    // try {
    //     return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    // } catch (error) {
    //     console.error('Encryption failed:', error);
    //     return null;
    // }
}

export function decryptData(ciphertext) {
    return atob(ciphertext);

    // if (!SECRET_KEY || !ciphertext) {
    //     try {
    //         console.log('cipher', ciphertext)
    //         return atob(JSON.parse(ciphertext));
    //     } catch (error) {
    //         return null;
    //     }
    // }
    // try {
    //     const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    //     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    // } catch (error) {
    //     console.error('Decryption failed:', error);
    //     return null;
    // }
}